import { useState, useEffect } from "react";
import { tv } from "../../lib/api/api";

const PrintedChannelHeader = ({channel, date}) => {
    const [name, setName] = useState('');
    const [media, setMedia] = useState({});

    useEffect(() => {
        tv.tvChannels()
            .then((res) => {
                res.channels.forEach(item => {
                    if (item.id === Number(channel)) {
                        setName(item.name);
                        setMedia(item.media.default);
                    }
                });
            })
            .catch((err) => {
                console.log(err);
            });
    }, [channel, date]);

    function changeOfDate(date) {
        let newDate = '';
        const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
        const index = Number(date.slice(5, 7));
        newDate += `${date.slice(8, 10)} ${months[index - 1]} ${date.slice(0, 4)}`;
        return newDate;
    }

    return (
        <>
            <div className="tv-program-print__channel-header">
                <div className="tv-program-print__channel-logo">
                    <img src={media.url} alt={name} width="64" height="64"/>
                </div>
                <div className="tv-program-print__channel-description">
                    <div className="tv-program-print__channel-name">{name}</div>
                    <div className="tv-program-print__channel-date">{changeOfDate(date)}</div>
                </div>
            </div>
        </>
    );
};

export default PrintedChannelHeader;